(function () {
  const selectRingBtn = document.querySelector('#add_ring_to_diamond');
  const productDataInput = document.querySelector('#product-data');
  const product = productDataInput ? JSON.parse(productDataInput.value) : null;
  const regularPaymentButtonInput = document.querySelector('#purchaseCompleteInput');
  const productForm = document.querySelector('#add-to-cart-form');
  const shapes = document.querySelectorAll('.shape-option');
  // filter varing media
  const mediaIDs = product
    ? Array.from(new Set(product.variants.map((item) => item.featured_media?.id)))
    : [];
  let variantMedia = [];

  // set the shape to the default selected shape of the product if no ring is ring shape is already selected.
  document.addEventListener('DOMContentLoaded', async (e) => {
    // Keep hidden Shape properties in sync with selected diamond shape
    const shapeRadios = document.querySelectorAll(
      '.shape-wrapper input[type="radio"][name^="product-"][name$="-shapes"]'
    );
    const shapeDisplayInput = document.querySelector('#selected-shape-display');
    const shapeInternalInput = document.querySelector('#selected-shape');

    const updateShapeProperties = () => {
      if (!shapeDisplayInput || !shapeInternalInput || !shapeRadios.length) return;
      const checked = Array.prototype.find.call(shapeRadios, (r) => r.checked);
      if (!checked) return;
      const shapeValue = (checked.value || '').toLowerCase();
      if (!shapeValue) return;
      shapeDisplayInput.value = shapeValue;
      shapeInternalInput.value = shapeValue;
    };

    if (shapeRadios.length && shapeDisplayInput && shapeInternalInput) {
      updateShapeProperties();
      Array.prototype.forEach.call(shapeRadios, (radio) => {
        radio.addEventListener('change', updateShapeProperties);
      });
    }

    const ringSelected = document.querySelector('.diamond-steps__steps__step.diamond-steps__steps__step--checked');
    if (ringSelected) {
      // if already selected then fetch it from cart attributes
      console.log('Ring already selected');
      let pdpShapes = document.querySelectorAll('.shape-wrapper input');
      let cart = await fetch('/cart.js')
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          return data;
        });
      let tempSelectedShape = cart.attributes.tempShape;
      const tempShapeExist = document.querySelector(`.shape-wrapper input[value="${tempSelectedShape}"]`);
      if (tempShapeExist != null && tempSelectedShape != undefined) {
        pdpShapes.forEach((input) => {
          if (input.value === tempSelectedShape) {
            input.click();
            input.checked = true;
          } else {
            input.checked = false;
          }
        });
      }
    } else {
      // if ring is not already selected then get the default shape from the search params.
      const searchParams = new URLSearchParams(window.location.search);
      const shape = (searchParams.get('shape') || '').toLowerCase();
      const selectedMetal = document.querySelector('[data-option-name="metal"] input:checked').value;
      let media_group_handle = `${window.hp_extend_product_media.product_title}-${selectedMetal.toLowerCase().replace('k ', '-k ')}-${shape}`;

      media_group_handle = media_group_handle
        .replace(/\//g, '') // Remove all slashes
        .replace(/\s+/g, '-') // Replace all sequences of spaces with a single dash
        .toLowerCase(); // Convert to lowercase
      // remove all '/' from the handle
      await fetch('/cart.js', {
        method: 'POST',
        body: JSON.stringify({
          attributes: { tempShape: shape, media_group_handle: media_group_handle },
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
    }
  });

  document.body.addEventListener('variantChange', (e) => {
    const variant = e.detail;
    document.querySelectorAll('.product-description-header__variant').forEach((el) => {
      el.innerHTML = variant.option1;
    });
    if (regularPaymentButtonInput) {
      regularPaymentButtonInput.value == variant.id;
      regularPaymentButtonInput.setAttribute('value', variant.id);
    }

    if (mediaIDs[0] !== undefined) {
      getMediaFor(variant.featured_media.id);
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 100);
    }
  });

  function getMediaFor(mediaId) {
    if (document.querySelector('[data-has-metafields-media')) return;
    variantMedia = [];
    const allMediaIDs = product.media.map((media) => media.id);
    for (let i = allMediaIDs.indexOf(mediaId); i < allMediaIDs.length; i++) {
      variantMedia.push(allMediaIDs[i]);
      if (mediaIDs.includes(allMediaIDs[i + 1])) break;
    }

    let slides = Array.from(document.querySelectorAll('.swiper-slide'));
    const bullets = Array.from(document.querySelectorAll('.swiper-pagination-bullet'));

    const showedSlides = [];
    variantMedia.forEach((variant) => {
      const slide = slides.find((slide) => slide.dataset.mediaId.includes(`-${variant}`));
      showedSlides.push(slide);
    });
    // hide all slides

    slides.forEach((slide) => {
      slide.classList.add('hide');
    });

    // show variant Media
    showedSlides.forEach((slide) => {
      slide.classList.remove('hide');
    });

    bullets.forEach((bullet, index) => {
      if (index >= showedSlides.length - 1) {
        if (!(index == bullets.length - 1)) bullet.classList.add('hide');
      }
    });
  }
  // filter varing media

  const parseValue = (value) => {
    try {
      const parsedValue = JSON.parse(value);
      // through error if the value is not am object
      if (typeof parsedValue !== 'object') {
        throw new Error('Value is not an object');
      }
      return parsedValue;
    } catch (error) {
      let decoded = value;
      decoded = decoded.replaceAll(/&quot;/g, '"').replaceAll(/\\/g, '');
      decoded = decoded.replaceAll(/\=\s*>\s*/g, ':');
      decoded = decoded.replaceAll('u0026quot;', '"');
      decoded = decoded.replaceAll('=u0026gt;', ':');
      decoded = decoded.replaceAll(' : ', ':');
      decoded = decoded.replaceAll('"{', '{');
      decoded = decoded.replaceAll('}"', '}');
      return JSON.parse(decoded);
    }
  };
  // add ring to diamond
  if (selectRingBtn) {
    const diamondInput = document.querySelector('input#diamond-cart-data');
    const diamondInputValue = diamondInput.value;
    const diamondScript = document.querySelector('#diamond-cart-data').textContent;
    const diamond = parseValue(diamondScript);
    let isSameShape = false;
    try {
      const productShape = JSON.parse(diamondInput.dataset.shape)[0];

      const shapeNote = document.querySelector('.shape-note');
      isSameShape = diamond ? diamond.shape.toLowerCase().trim() === productShape.toLowerCase().trim() : true;

      //if (!isSameShape) shapeNote.classList.remove('hide');
    } catch (error) {
      console.log(error);
    }

    selectRingBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      const productShape = document.querySelector('input:checked + .shape-option').dataset.shape;
      isSameShape = diamond ? diamond.shape.toLowerCase().trim() === productShape.toLowerCase().trim() : true;
      const searchParams = new URLSearchParams(window.location.search);
      const variantID = searchParams.get('variant');
      const product = JSON.parse(selectRingBtn.dataset.product);
      let variant = product.variants.find((variant) => variant.id == variantID);
      const variantUrl = `/products/${product.handle}?view=diamond-ring&variant=${variantID}`;
      const currentRingSize =
        document.querySelector('input[name="properties[Finger size]"]:checked')?.value ||
        document.querySelector('input[name="option-1"][type="radio"]:checked')?.value ||
        document.querySelector('select[name="option-1"]')?.value ||
        document.querySelector('select[name="properties[Finger size]"]')?.value;

      const shapeOptions = document.querySelectorAll('.shape-option[data-shape]');
      const shapesArray = [];

      shapeOptions.forEach((div) => {
        const shape = div.getAttribute('data-shape');
        shapesArray.push(shape);
      });
      console.log('Hello Diamond shape: ', productShape);
      const allSizes = selectRingBtn.dataset.sizes;
      variant = {
        ...variant,
        productID: product.id,
        url: variantUrl,
        product,
        variantMedia: variantMedia,
        shape: productShape,
        availableShapes: shapesArray,
        currentRingSize,
        allSizes,
      };
      console.log('Adding ring to cart');

      toggleLoader();

      const engravingText = document.querySelector('textarea[name="properties[Engraving text]"]')?.value;
      const engravingFont = engravingText ? document.querySelector('select[name="properties[Engraving font]"]')?.value : "";
      const clawStyle = document.querySelector('input[name="properties[Claw style]"]:checked')?.value;
      // debugger;
      await fetch('/cart.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json;',
        },
        body: JSON.stringify({
          attributes: {
            engravingText,
            engravingFont,
            clawStyle,
            ring: {
              name: variant.name,
              id: variant.id,
              price: variant.price,
              productID: variant.productID,
              url: variant.url,
              shape: variant.shape,
              allSizes: Array.isArray(variant.allSizes) ? variant.allSizes.join(',') : variant.allSizes,
              option1: variant.option1,
              option2: variant.option2,
              currentRingSize: variant.currentRingSize,
              variantMedia: variant.variantMedia,
              productHandle: variant.product.handle,
            },
          },
        }),
      });

      if (selectRingBtn.dataset.isComplete === 'true') {
        window.location = '/pages/full-ring';
      } else {
        window.location = `/pages/diamonds?shapes=${productShape.toLowerCase().trim()}`;
      }
      toggleLoader();
    });
  }
  // add ring to diamond
})();
